import React from 'react';
import { FaArrowCircleLeft as Icon } from 'react-icons/fa';
import './Cart.css';
import { useDispatch, useSelector } from 'react-redux';
import { removeAll, removeProduct } from '../Actions';
import { NavLink } from 'react-router-dom';

function Cart() {
    const cartData = useSelector((state) => state.products);
    console.log(cartData);
    const dispatch = useDispatch();
    let totalPrice = 0;
    for (let i = 0; i < cartData.length; i++) {
        totalPrice += cartData[i].price;
    }

    let cartClass = 'cart filter';

    if (cartData.length === 0) {
        cartClass = 'cart';
    }

    return (
        <div className={cartClass}>
            <h1 className='cart__heading'>CART</h1>
            <NavLink to='/'>
                <Icon className='cart__icon' />
            </NavLink>

            {cartData &&
                cartData.map((product) => (
                    <div
                        className='cart__item'
                        key={product.name + Math.random()}
                        id={product.name + Math.random()}
                    >
                        <span className='cart__itemName'>{product.name}</span>
                        <span className='cart__itemPrice'>
                            ${product.price}
                        </span>
                        <button
                            className='cart__itemRemove'
                            onClick={() =>
                                dispatch(removeProduct(product.index))
                            }
                        >
                            X
                        </button>
                    </div>
                ))}
            {cartData.length !== 0 && (
                <h1 className='cart__value'>
                    Cart value: <span>$</span>
                    {totalPrice.toFixed(2)}
                </h1>
            )}
            {cartData.length !== 0 && (
                <button
                    className='cart__clear'
                    onClick={() => dispatch(removeAll())}
                >
                    Clear Cart
                </button>
            )}

            {cartData.length === 0 ? (
                <div className='cart__backgroundImage' />
            ) : (
                <div className='cart__backgroundImage filter' />
            )}
        </div>
    );
}

export default Cart;
